export default __webpack_public_path__ + "static/media/Leg_right.5e66ade6.svg";